/**
 * Filename for the BOM CSV export (download, Amplify S3 key and the external
 * S3 upload all use the same string). Every dynamic segment goes through the
 * shared sanitiser in exportFilename.js (CONF-208); the CSV *contents* keep
 * their own cleaning in buildCsvQuoteNumber.
 */
import { sanitizeFilenamePart } from './exportFilename';

export { sanitizeFilenamePart };

export function buildBomCsvFilename(config = {}, now = new Date()) {
  const serial = sanitizeFilenamePart(config.configuratorQuoteSerial);
  const salesforce = sanitizeFilenamePart(config.salesforceQuoteNumber);
  // ISO timestamp with ':' and '.' replaced — already filename-safe.
  const timestamp = now.toISOString().replace(/[:.]/g, '-');
  return `Quote_Number_${serial}-${salesforce}_BOM_${timestamp}.csv`;
}
